<template>
  <div class="chat-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="navTitle" @click-left="onClickLeft" :left-arrow="true"> </van-nav-bar>
    <audio :src="msgTipAudio" preload="auto" id="tipMusic" hidden="hidden"></audio>
    <!-- 聊天内容区域 -->
    <div class="chat-content" ref="chatContent">
      <!-- 消息列表 -->
      <div class="message-list">
        <div v-for="(message, index) in messages" :key="index"
          :class="['message-item', message.senderId == customerId ? 'sent' : 'received']">
          <!-- 时间分隔线 -->
          <div v-if="shouldShowTime(index)" class="time-divider">
            {{ formatTime(message.createTime) }}
          </div>

          <!-- 消息内容 -->
          <div class="message-wrapper">
            <!-- 头像 -->
            <div class="message-avatar">
              <van-image :src="message.senderId == customerId ? userAvatar : serviceAvatar" round width="36" height="36"
                fit="cover" />
            </div>

            <!-- 消息气泡 -->
            <div class="message-bubble">
              <!-- 文本消息 -->
              <div v-if="message.messageType === 'text'" class="text-content">
                {{ message.content }}
              </div>

              <!-- 图片消息 -->
              <div v-else-if="message.messageType === 'image'" class="image-content">
                <van-image :src="message.content" width="150" height="150" fit="cover" radius="8"
                  @click="previewImage(message.content)" />
              </div>

              <!-- 系统消息 -->
              <div v-else-if="message.messageType === 'system'" class="system-content">
                {{ message.content }}
              </div>

              <!-- 关键词消息 -->
              <div v-else-if="message.messageType === 'keywords'" class="keywords-content">
                <div class="keywords-title">热门问题：</div>
                <div class="keywords-list">
                  <van-tag v-for="(keyword, keywordIndex) in message.content" :key="keywordIndex" class="keyword-item"
                    @click="sendKeyword(keyword)">
                    {{ keyword }}
                  </van-tag>
                </div>
              </div>

              <!-- 富文本消息 -->
              <div v-else-if="message.messageType === 'rich'" class="rich-content" v-html="message.content"></div>

              <!-- 发送状态 -->
              <div v-if="message.senderId == customerId" class="message-status">
                <van-icon v-if="message.status === 'failed'" name="warning-o" size="12" color="#ee0a24" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 输入区域 -->
    <div class="chat-input">
      <div class="input-wrapper">
        <!-- 附加功能按钮 -->
        <van-button icon="plus" size="small" round @click="showActionSheet = true" />

        <!-- 文本输入框 -->
        <van-field v-model="messageInput" placeholder="请输入消息..." @keyup.enter="sendMessage" id="message-input"
          right-icon="smile-o" @click-right-icon="toggleEmojiPicker" />

        <van-popup v-model:show="showEmojiPicker" position="bottom" :style="{ height: '36%' }">
          <div class="emoji-picker">
            <van-tabs v-model:active="activeEmojiTab" animated>
              <van-tab v-for="(category, index) in emojiCategories" :key="index" :title="category.name">
                <div class="emoji-grid">
                  <div v-for="(emoji, emojiIndex) in category.emojis" :key="emojiIndex" class="emoji-item"
                    @click="addEmoji(emoji)">
                    {{ emoji }}
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </van-popup>

        <van-button type="primary" size="small" style="width: 70px" :disabled="!messageInput.trim()"
          @click="sendMessage">
          发送
        </van-button>
      </div>
    </div>

    <!-- 功能选择面板 -->
    <van-action-sheet v-model:show="showActionSheet" :actions="actionSheetActions" @select="onActionSelect"
      cancel-text="取消" />

    <!-- 图片上传 -->
    <van-uploader v-show="false" ref="imageUploader" :max-size="500 * 1024" :after-read="afterImageRead"
      accept="image/*" />
  </div>
</template>

<script>
import socketService from '@/utils/socketService';
import { showToast, showImagePreview } from 'vant';
import msgTipAudioUrl from '@/assets/msgTip.mp3';
import userAvatarUrl from '@/assets/customerImg.png';
import serviceAvatarUrl from '@/assets/serviceImg.png';
import request from '@/utils/request'

export default {
  name: "ChatPage",
  data() {
    return {
      customerId: null,
      customerName: null,
      agentStatus: 'offline',
      messages: [],
      messageInput: '',
      sessionId: null,
      userAvatar: userAvatarUrl,
      serviceAvatar: serviceAvatarUrl,
      msgTipAudio: msgTipAudioUrl,
      showActionSheet: false,
      socketId: null,
      actionSheetActions: [
        { name: '发送图片', value: 'image', icon: 'photo-o' },
        { name: '转人工客服', value: 'human', icon: 'manager-o' }
      ],
      showEmojiPicker: false,
      activeEmojiTab: 0,
      emojiCategories: [
        {
          name: '常用',
          emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰']
        },
        {
          name: '表情',
          emojis: ['😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏']
        },
        {
          name: '物品',
          emojis: ['👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐']
        }
      ],
      navTitle: '智能在线客服',
      agentName: '',
    };
  },

  mounted() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      const userInformation = JSON.parse(userInfo);
      this.customerId = userInformation.customerId;
      this.customerName = userInformation.customerName;
    }
    this.initSocket();
  },
  beforeUnmount() {
    socketService.disconnect();
  },

  methods: {
    initSocket() {
      try {
        const socket = socketService.connect(process.env.VUE_APP_CHAT_SOCKET_URL, this.customerId);
        this.socketId = socket.id;
        socket.on('systemMessage', (data) => {
          switch (data.type) {
            case 'joinSuccess':
              this.handleJoinSuccess(data);
              break;
            case 'joinError':
              this.handleJoinError(data);
              break;
            case 'sessionClosed':
              this.handleSessionClosed(data);
              break;
            case 'userOffline':
              this.handleUserOffline(data);
              break;
            case 'agentOnline':
              this.sessionId = data.sessionId;
              this.agentStatus = 'online';
              this.navTitle = `客服 ${data.agentName} 已上线`;
              this.agentName = data.agentName;
              break;
            case 'errorMessage':
              this.handleUserOffline(data);
              break;
          }
        });

        socket.on('receiveMessage', (data) => {
          this.handleNewMessage(data);
        });

        socket.on('robotMessage', (data) => {
          this.hadnleRobotMessage(data);
        });

        this.requestKeywords();
      } catch (error) {
        console.error('连接失败:', error)
        showToast('连接失败，请检查网络')
      }
    },

    requestKeywords() {
      request.get("/front/chat/keywords")
        .then(result => {
          if (result.code === 200) {
            this.hadndleKeywords(result.data);
          }
        })
    },

    hadndleKeywords(keywords) {
      const keywordsMessage = {
        id: Date.now(),
        content: keywords,
        messageType: 'keywords',
        senderId: 0,
        createTime: new Date()
      };
      this.messages.push(keywordsMessage);
      this.scrollToBottom();
      this.playMusic();
    },

    hadnleRobotMessage(data) {
      const rotbotMessage = {
        id: Date.now(),
        senderId: 0,
        createTime: new Date(),
        ...data
      }
      this.messages.push(rotbotMessage);
      this.scrollToBottom();
      this.playMusic();
    },
    handleJoinSuccess(data) {
      this.agentStatus = 'online';
      this.sessionId = data.sessionId;

       if (data.messages.length > 0) {
        this.messages.push(...data.messages)
      }

      if (data.agentName) {
        this.agentName = data.agentName;
        this.navTitle = `客服 ${data.agentName} 已上线`
      } else {
         this.messages.push({
          id: Date.now(),
          content: "当前暂无客服在线，您有什么问题可以给我们留言，客服上线后立刻给您回复。",
          messageType: 'text',
          senderId: 0,
          createTime: new Date()
        })
      }
     
      this.playMusic();
      this.scrollToBottom();
    },

    handleJoinError(data) {
      this.agentStatus = 'offline';

      const errorMessage = {
        id: Date.now(),
        content: data.message,
        messageType: 'text',
        senderId: 0,
        createTime: new Date()
      };

      this.messages.push(errorMessage);
      this.scrollToBottom();
      this.playMusic();
    },

    handleNewMessage(data) {
      const message = {
        id: Date.now(),
        sessionId: data.sessionId,
        senderId: data.senderId,
        content: data.content,
        messageType: data.messageType,
        createTime: new Date()
      };

      this.messages.push(message);
      this.scrollToBottom();
      this.playMusic();
    },

    handleUserOffline(data) {
      this.agentStatus = 'offline';
      this.navTitle = `客服${this.agentName}已下线`
      this.playMusic();
    },

    handleSessionClosed(data) {
      this.agentStatus = 'offline';
      this.navTitle = `客服${this.agentName}已下线`
      const message = {
        id: Date.now(),
        sessionId: this.sessionId,
        senderId: 0,
        content: data.message,
        messageType: 'text',
        createTime: new Date()
      };

      this.messages.push(message);
      this.scrollToBottom();
      this.playMusic();
    },

    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
      this.activeEmojiTab = 0; // 默认显示第一个标签页
    },

    addEmoji(emoji) {
      this.messageInput += emoji;
      this.showEmojiPicker = false;
    },
    sendKeyword(keyword) {
      if (keyword == '转人工客服') {
        this.requestHumanService();
      } else {
        this.messageInput = keyword;
        this.sendMessage();
      }
    },
    sendMessage() {
      if (!this.messageInput.trim()) return;

      const messageData = {
        sessionId: this.sessionId,
        senderId: this.customerId,
        content: this.messageInput,
        messageType: 'text'
      };

      socketService.sendRobotMessage(messageData)

      // 本地添加消息
      const localMessage = {
        id: Date.now(),
        sessionId: this.sessionId,
        senderId: this.customerId,
        content: this.messageInput,
        messageType: 'text',
        createTime: new Date()
      };

      this.messages.push(localMessage);
      this.messageInput = '';

      this.scrollToBottom();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContent;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    // 功能选择
    onActionSelect(action) {
      switch (action.value) {
        case 'image':
          this.$refs.imageUploader.chooseFile();
          this.showActionSheet = false;
          break
        case 'human':
          this.requestHumanService()
          this.showActionSheet = false;
          break
      }
    },

    // 图片上传后处理
    afterImageRead(raw) {
      try {
        const formData = new FormData();
        formData.append('file', raw.file);
        request.post("/common/chat/upload", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(result => {
            if (result.code == 200) {

              const messageData = {
                sessionId: this.sessionId,
                senderId: this.customerId,
                content: result.url,
                messageType: 'image'
              };

              if (this.agentStatus !== 'online') {
                socketService.sendRobotMessage(messageData)
              } else {
                socketService.sendMessage(messageData);
              }

              // 本地添加消息
              const localMessage = {
                id: Date.now(),
                sessionId: this.sessionId,
                senderId: this.customerId,
                content: result.url,
                messageType: 'image',
                createTime: new Date()
              };

              this.messages.push(localMessage);
              this.scrollToBottom();
            }
          });
      } catch (error) {
        showToast("图片发送失败，请重试!");
      }
    },

    // 预览图片
    previewImage(imageUrl) {
      showImagePreview([imageUrl])
    },

    // 请求人工客服
    requestHumanService() {
      const data = {
        userId: this.customerId,
        role: 'customer',
        nickName: this.customerName,
      }
      socketService.joinChat(data);
      showToast('已为您转接人工客服，请稍候...')
    },

    playMusic() {
      let audio = document.getElementById("tipMusic");
      if (audio != null) {
        audio.currentTime = 0;
        audio.play();
      }
    },

    // 是否显示时间
    shouldShowTime(index) {
      if (index === 0) return true

      const current = this.messages[index]
      const previous = this.messages[index - 1]

      // 如果距离上一条消息超过5分钟，显示时间
      return current.createTime - previous.createTime > 5 * 60 * 1000
    },

    // 格式化时间
    formatTime(createTime) {
      const date = new Date(createTime)
      const now = new Date()

      if (date.toDateString() === now.toDateString()) {
        // 今天，只显示时间
        return date.toLocaleTimeString('zh-CN', {
          hour: '2-digit',
          minute: '2-digit'
        })
      } else {
        // 其他日期，显示日期和时间
        return date.toLocaleString('zh-CN', {
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      }
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
      socketService.disconnect();
    }
  }
}
</script>

<style scoped>
.chat-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 4px;
}

.status-text {
  font-size: 12px;
  color: #646566;
}

.chat-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  padding-bottom: 0;
}

.system-message {
  text-align: center;
  padding: 12px;
  margin-bottom: 16px;
  background-color: #fff3cd;
  border-radius: 8px;
  font-size: 14px;
  color: #856404;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.system-message.error {
  background-color: #f8d7da;
  color: #721c24;
  flex-direction: column;
  gap: 8px;
}

.welcome-message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
  padding: 16px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.welcome-text {
  flex: 1;
}

.service-name {
  font-weight: 600;
  color: #323233;
  margin-bottom: 4px;
}

.welcome-content {
  color: #646566;
  font-size: 14px;
  line-height: 1.5;
}

.message-list {
  padding-bottom: 16px;
}

.message-item {
  margin-bottom: 16px;
}

.time-divider {
  text-align: center;
  font-size: 12px;
  color: #969799;
  margin-bottom: 12px;
  position: relative;
}

.time-divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #ebedf0;
  z-index: 1;
}

.time-divider span {
  background-color: #f5f5f5;
  padding: 0 12px;
  position: relative;
  z-index: 2;
}

.message-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.message-item.sent .message-wrapper {
  flex-direction: row-reverse;
}

.message-avatar {
  flex-shrink: 0;
}

.message-bubble {
  max-width: 70%;
  position: relative;
}

.text-content {
  background-color: white;
  padding: 12px 16px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}

.message-item.sent .text-content {
  background-color: #1989fa;
  color: white;
}

.message-item.received .text-content {
  background-color: #f0f0f0;
  color: #646566;
  text-align: center;
  font-size: 12px;
}

/* 表情选择器样式 */
.emoji-picker {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 16px;
  overflow-y: auto;
}

.emoji-item {
  font-size: 24px;
  text-align: center;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
}

.emoji-item:hover {
  background-color: #f7f8fa;
}

.image-content {
  border-radius: 8px;
  overflow: hidden;
}

.system-content {
  background-color: #fff3cd;
  color: #856404;
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 12px;
  text-align: center;
}

.message-status {
  text-align: right;
  margin-top: 4px;
}

.message-item.received .message-status {
  text-align: left;
}

.chat-input {
  background-color: white;
  padding: 12px 16px;
  border-top: 1px solid #ebedf0;
}

.input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.message-input {
  flex: 1;
  background-color: #f7f8fa;
  border-radius: 20px;
}

:deep(.message-input .van-field__control) {
  background-color: transparent;
  border: none;
  padding: 8px 16px;
}

/* 滚动条样式 */
.chat-content::-webkit-scrollbar {
  width: 4px;
}

.chat-content::-webkit-scrollbar-track {
  background: transparent;
}

.chat-content::-webkit-scrollbar-thumb {
  background: #c8c9cc;
  border-radius: 2px;
}

.chat-content::-webkit-scrollbar-thumb:hover {
  background: #a6a7ab;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .chat-content {
    padding: 12px;
  }

  .message-bubble {
    max-width: 80%;
  }

  .text-content {
    padding: 10px 14px;
    font-size: 13px;
  }
}

.keywords-content {
  background-color: white;
  padding: 12px;
  border-radius: 8px;
  margin: 8px 0;
}

.keywords-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.keywords-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.keyword-item {
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
}

.keyword-item:hover {
  background-color: #1989fa;
  color: white;
}


.rich-content {
  background-color: white;
  padding: 12px 16px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  text-align: left;
}

.message-item.sent .rich-content {
  background-color: #1989fa;
  color: white;
}

.message-item.received .rich-content {
  background-color: #f0f0f0;
  color: #333;
}

/* 富文本内容中的各种标签样式 */
/* 富文本内容中的各种标签样式 */
:deep(.rich-content p) {
  margin: 0 0 10px 0;
}

:deep(.rich-content p:last-child) {
  margin-bottom: 0;
}

:deep(.rich-content strong) {
  font-weight: bold;
}

:deep(.rich-content em) {
  font-style: italic;
}

:deep(.rich-content img) {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 5px 0;
  display: block;
}

:deep(.rich-content a) {
  color: #1989fa;
  text-decoration: none;
}

:deep(.message-item.sent .rich-content a) {
  color: #add8ff;
}
</style>